import { apiRequest, apiSecureRequest } from '@utils/request';
import { getDistinctId } from '@utils/analytics';
import { LDContext } from 'launchdarkly-js-client-sdk';
import { useAppStore } from '@stores/app';

export async function recordLD(testName: string): Promise<void> {
	const mixpanelId = getDistinctId();
	const payload = {
		testName,
		mixpanelId
	};
	const appStore = useAppStore();

	if (appStore.isAuthenticated && !appStore.isAdvisor && !appStore.isReadOnlyAccess) {
		await apiSecureRequest.post('/ld-ab-test/record', payload);
	} else {
		await apiRequest.post('/ld-ab-test/record', payload);
	}
}

/**
 * NOTE: This should only be used with the isInMarketingSiteTest util.
 */
export async function recordMarketingSiteLD(testName: string, testVariant: string): Promise<void> {
	const mixpanelId = getDistinctId();

	const payload = {
		testName,
		mixpanelId,
		group: testVariant
	};

	await apiRequest.post('/client-ab-test/record', payload, { suppressToast: () => true });
}

export function getLDUserContext(key: string | undefined): LDContext {
	const ldUserContext: LDContext = { kind: 'user', client_type: 'web', key };

	if (import.meta.env.DEV || import.meta.env.MODE === 'omega') {
		const localUser = localStorage.getItem('LocalUser') ?? import.meta.env.VITE_LD_USER_HEADER ?? '';

		ldUserContext['LocalUser'] = localUser;
	}

	return ldUserContext;
}
